import { addressFloorTaggingActions } from './addressFloorTaggingActionCreator';

const initialState = {
  isLoading: false,
  isLoaded: false,
  taskboardData: [],
  error: null,
  pageNumber: 0,
  pageSize: 20,
  totalElements: 0,
  pendingTaskCount: {},
  poDetails: [],
  isPoDetailsLoading: false,
  filters: {}
};

const addressFloorTaggingReducer = (state = initialState, action) => {
  switch (action.type) {
    case addressFloorTaggingActions.GET_HIGHER_FLOOR_VAS_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case addressFloorTaggingActions.UPDATE_PAGE_NUMBER: {
      return Object.assign({}, state, { pageNumber: action.payload });
    }
    case addressFloorTaggingActions.UPDATE_PENDING_TASK_COUNT: {
      return Object.assign({}, state, { pendingTaskCount: action.payload });
    }
    case addressFloorTaggingActions.UPDATE_FILTER: {
      return Object.assign({}, state, {
        filters: Object.assign(state.filters, {
          [action.key]: action.payload,
          pageNumber: 0
        })
      });
    }
    default: {
      return state;
    }
  }
};

export default addressFloorTaggingReducer;
